import dayjs from '@/lib/dayjs'
import { ReportingBucketSize } from '@/api/model'

export const BUCKET_SIZE_OPTIONS: ReportingBucketSize[] = [
  ReportingBucketSize.Daily,
  ReportingBucketSize.Weekly,
  ReportingBucketSize.Monthly,
]

// Backend sends bucket dates as DateOnly ("YYYY-MM-DD"), both ends inclusive
export function formatBucketAxisLabel(startDate: string, bucketSize: ReportingBucketSize): string {
  const start = dayjs(startDate, 'YYYY-MM-DD')
  // Months count from the start date; only a bucket starting on the 1st is a calendar month
  if (bucketSize === ReportingBucketSize.Monthly) {
    return start.date() === 1 ? start.format('MM.YYYY') : start.format('DD.MM.YY')
  }
  return start.format('DD.MM.')
}

export function formatBucketRange(startDate: string, endDate: string): string {
  const start = dayjs(startDate, 'YYYY-MM-DD')
  const end = dayjs(endDate, 'YYYY-MM-DD')
  if (start.isSame(end, 'day')) {
    return start.format('DD.MM.YYYY')
  }
  return `${start.format('DD.MM.YYYY')} – ${end.format('DD.MM.YYYY')}`
}

export function completionRate(completed: number, total: number): number | null {
  return total > 0 ? Math.round((completed / total) * 100) : null
}
